<template>
	<div class="contents">
		<h3 class="mark">
			<div class="type">
				<span>
					<img src="../assets/result-detail-communcation-icon01.svg" alt="*" />あなたのコミュニケーション
				</span>
			</div><!-- end .type -->
			<div class="cover">
				積極型{{communicateResult.percentageLeft}}%、独立型{{communicateResult.percentageRight}}%
			</div><!-- end .cover -->
		</h3><!-- end .mark -->
		<div class="sentence">
			<div class="catch">
				<span class="left">
					Detailed
				</span>
				<span class="right">
					explanation
				</span>
			</div><!-- end .catch -->
			<!-- ////////////////////////////////////////////////////////////////////////// -->
			<!-- ++++++++++++++++++++++++++++++ Paragraphr01 ++++++++++++++++++++++++++++++ -->
			<!-- ////////////////////////////////////////////////////////////////////////// -->	
			<h2>人と積極的に関わってきた歴史があり、対人関係においては十分なスキルがある</h2>
			<img src="../assets/result-detail-communication-inleft01.svg" alt="*" class="visual" />
			<div class="caption">
				コミュニケーションに長けていくと、内向型の独自の特徴や感性を大きなプラスに好転させることができる
			</div><!-- end .caption -->
			<p>人生を豊かにするうえで不可欠なのが、他人との関わりです。家族、恋人、友人、仲間、ライバル、同僚、先輩、後輩など、あらゆるシーンで「他人との関わり方」が、あなたの幸福度を強く決めていくのです。</p>
			<p>そこで重要になっていくのが、このコミュニケーションタイプです。今回、あなたのコミュニケーションスコアは積極型78%となりました。コミュニケーションにおいては非常に豊かなスキルと経験を持ち合わせていると言えるでしょう。</p>

			<!-- ////////////////////////////////////////////////////////////////////////// -->
			<!-- ++++++++++++++++++++++++++++++ Paragraphr02 ++++++++++++++++++++++++++++++ -->
			<!-- ////////////////////////////////////////////////////////////////////////// -->	
			
			<h2>本音を引き出す習慣を積むことで、あなたは多くの人からより好意的に支持されていく</h2>
			<img src="../assets/result-detail-communication-inleft02.svg" alt="*" class="visual" />
			<div class="caption">
				自分の内面と一人対話することが得意な内向型は、本来、相手の本音を汲み取るコミュニケーション能力がとても高い
			</div><!-- end .caption -->
			<p>内向性が強いタイプは、コミュニケーションの場で一般的に「引っ込み思案」「控え目」という印象がありませんか？しかし、、それはとても大きな間違いです。なぜなら、戦略的にコミュニケーションスキルを積んだ内向型の人は、自身の内向的な思考特性を「強み」として発揮し、どんどん相手と関わっているからです。</p>
			<p>内向性の高い人は、相手の内面がどう構成されているのかについて熟考することができます。そのため、相手の本音を開示することにおいては、外交的な人より長けているのです。</p>
			<p>つまり、コミュニケーションの現場では、外向型の人を押しのけ、内向型の人がコンペを勝ち取ったり、異性から好意を勝ち取ったり、部下から支持を得ていたり、そういったことが起きているということです。</p>
			<p>内向度のスコアが高く、コミュニケーションも積極型の人は、「常に相手から本音を心地よく引き出す」ということに徹すれば、とても好意的に思われるのです。それは、相手が周囲の人よりも、あなたに本音を開示することが心地よくなるからです。</p>
			<p>あなたは、コメディアンのように爆笑を取る面白さがなくても、人に面白味を与えることができます。世間話のような浅い話ではなく、相手の価値観や考え方を深く引き出す時間を増やしていくようにして下さい。</p>
			<p>内向型が本音を引き出すコミュニケーション力を高めれば、最終的には、相手が自分で認識できていない隠れた本音や感情を察知することもできるようになります。そうなると、相手にとって、あなたは唯一無二の理解者であり、特別な存在となっていきます。ビジネスでもプライベートでも、同性異性関係なく、様々なシチュエーションであなたは求められていくでしょう。</p>
			<p>積極的に相談役を買ったり、議論や討論を交わしたりする中で、あなたの資質をさらに磨いていって下さい。</p>
			<!-- ////////////////////////////////////////////////////////////////////////// -->
			<!-- ++++++++++++++++++++++++++++++ Paragraphr03 ++++++++++++++++++++++++++++++ -->
			<!-- ////////////////////////////////////////////////////////////////////////// -->	
			<h2>社交的なモチベーションを妨げている要因を1つ1つ潰していけば、あなたは最高のコミュニケーターになれる</h2>
			<img src="../assets/result-detail-communication-inleft03.svg" alt="*" class="visual" />
			<div class="caption">
				自分とは違うものに対して興味を持ち、課題を見つけ、小さなチャレンジを重ねていく
			</div><!-- end .caption -->
			<p>「もっと人から好かれたいいのに」といったように、あなたは、対人関係の中で、自分のコミュニケーションに不満を持っていますか？恋愛や仕事でもっと他人と分かり合えたらいいのにという悩みを持っていますか？</p>
			<p>そうだとすれば、あなたは自身の内向性に寄り添ってコミュニケーションを積むだけで、まだまだ大きな幸福が待っていると断言することができます。あなたはもっと幸せになれるのです。</p>
			<p>私たちは、自身の研究を通して、最高のコミュニケーターとは、「内向型の人が、己の内向性を極めつつ、コミュニケーションスキルを後天的に積んだ人」だと結論付けています。
			<p>内向型の人がコミュニケーションスキルを高めれば、相手の内面を内省でき、把握した内容をもとにコミュニケーションという形でアウトプットし、他人へのベストな行動を取ることができるからです。</p>
			<p>だから、あなたは今の自身の社交性に足りないものと1つ1つ向き合ってみて下さい。例えば、自尊心が低くて、あまり積極的に会話ができない人は、なるべく自尊心を高く保つ工夫に取り組むべきです。</p>
			<p>外見の清潔感を高くする、最初から結果が悪くても挑戦を自己評価として受け入れる、そんな少しの工夫でも構いません。とにかく、自分の心の余裕の根拠になるものを1つずつストックしていけば、あらゆるコミュニティの中で積極性を出すことができます。そうなれば、あなたの内向性はあらゆるコミュニケーションの中で長所として明らかに際立っていくでしょう。
			</p>
			<p>心の中に興味の炎を灯し続け、新たな知識や感性を増やすことを諦めないで下さい。たまにはストレスや心労を覚悟で、幹事などのホスト役を買って出たり、まったく知らない業界や分野の専門家の話を聞いたり、自分だけのペースに収まらない時間を作っていきましょう。そうすることで、長期的に見れば、あなたはコミュニケーションによって様々な恩恵を受けるようになるでしょう。歳を重なるごとに魅力的になっていくのです。</p>
		</div><!-- end .sentence -->
	</div><!-- end .guidance -->			
</template>

<script>


export default {
	name: 'ResultDetailCommunicationInLeft',
	components: {

	},
	
	data: function () {
		return {

		}
	},
	props:[

	],
	computed: {
		//level
		levelResult:function(){
			return this.$store.getters.levelResult
		},		
		// communicate
		communicateResult:function(){
			return this.$store.getters.communicateResult
		},
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">



</style>
